import React, { useState } from 'react';
import Sidebar from '../../partials/Sidebar';
import Header from '../../partials/Header';
import DashboardCard17 from '../../partials/dashboard/DashboardCard17';
import Banner from '../../partials/Banner';
import { useNavigate } from "react-router-dom";
import DashboardCard05 from '../../partials/dashboard/DashboardCard05';
import DashboardCard06 from '../../partials/dashboard/DashboardCard06';
import DashboardCard08 from '../../partials/dashboard/DashboardCard08';
import DashboardCard09 from '../../partials/dashboard/DashboardCard09';
import DashboardCard11 from '../../partials/dashboard/DashboardCard11';
import DashboardCard27 from '../../partials/dashboard/DashboardCard27';
function Timetracking() {

    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <div className="flex h-screen overflow-hidden">
            <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
            <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
                <main className="grow">
                    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                        <div className="grid grid-cols-12 gap-1 justify-center items-center">
                            {/* <DashboardCard06 /> */}
                            {/* <DashboardCard11 /> */}
                        </div>
                        <div className="grid grid-cols-12 gap-1 justify-center items-center">
                            {/* <DashboardCard08 /> */}
                            {/* <DashboardCard09 /> */}

                        </div>
                        <DashboardCard27 />

                    </div>
                </main>
                <Banner />
            </div>
        </div>
    );
}

export default Timetracking;